import { ServiceResult } from '../models/api-shared.models';
import {
  CustomerProductPriceResult,
  GetCustomerProductPriceRequest,
  GetOrderEntryCustomerProductPriceRequest,
  GetOrderReviewCustomerProductPriceRequest,
  OrderEntryCustomerProductPriceResult,
  OrderReviewCustomerProductPriceResult,
} from '../models/customer-product-price.models';
import ApiService from './api-service';

class CustomerProductPriceService extends ApiService {
  private static classInstance: CustomerProductPriceService;
  private customerProductPriceController: AbortController;

  private constructor() {
    super('CustomerProductPrice');
    this.customerProductPriceController = new AbortController();
  }

  public abortGetCustomerProductPrice = (): void => {
    this.customerProductPriceController.abort();
  };
  public getCustomerProductPrice(request: GetCustomerProductPriceRequest): ServiceResult<CustomerProductPriceResult[]> {
    this.customerProductPriceController = new AbortController();
    return this.post(
      `${this.persistUrl}/GetCustomerProductPrice`,
      request,
      undefined,
      this.customerProductPriceController.signal
    );
  }

  public getOrderReviewCustomerProductPrice(
    request: GetOrderReviewCustomerProductPriceRequest
  ): ServiceResult<OrderReviewCustomerProductPriceResult[]> {
    return this.get(`${this.persistUrl}/GetOrderReviewCustomerProductPrice`, request);
  }

  public getOrderEntryCustomerProductPrice(
    request: GetOrderEntryCustomerProductPriceRequest
  ): ServiceResult<OrderEntryCustomerProductPriceResult> {
    this.customerProductPriceController = new AbortController();
    return this.post(
      `${this.persistUrl}/GetOrderEntryCustomerProductPrice`,
      request,
      undefined,
      this.customerProductPriceController.signal
    );
  }

  public static getInstance(): CustomerProductPriceService {
    if (!this.classInstance) {
      this.classInstance = new CustomerProductPriceService();
    }
    return this.classInstance;
  }
}

export default CustomerProductPriceService;
